import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GerarPlanilhaDadosService {

  constructor( private readonly http : HttpClient ) { }

  startFileGeneration(idEmpresaLogada, url) {
    return this.http.get<any>(`/apiconnect/orders/excel-data/${idEmpresaLogada}/companies/${url}`);
  }

  getFileGenerationStatus(idDownload, tipoArquivo:any) {
    tipoArquivo ??= 'xls';
    return this.http.get<any>(`/apiconnect/core/download-status/${idDownload}/${tipoArquivo}/files`);
  }

  public getDepartamento (idEmpresa) {
    return this.http.get( `/apiconnect/importation/company/departament/${idEmpresa}/companies` );
  }

  public getEnderecos(idEmpresa) {
    return this.http.get(`/apiconnect/importation/billing-address/${idEmpresa}/companies`);
  }
}
